angular.module('bmsApp.settings')
	.factory('MMVisitJobRoomSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/mm/job/visit-room/index', params);
		},
	}
}]);




